import React from 'react';
import './style.css';
import { Button } from '@chatui/core';
interface TalkingHeadProps {
  playerRef: React.RefObject<HTMLVideoElement>;
  videoSrc: string;
  isIdle?: boolean;
  onEnded?: () => void;
  background?: string;
  idleVideo?: string;
  muted?: boolean;
  toggleMute?: () => void;
}

const TalkingHead = (props: TalkingHeadProps) => {
  const {
    playerRef,
    videoSrc,
    isIdle = true,
    onEnded = () => {},
    idleVideo,
    muted = false,
    toggleMute = () => {},
  } = props;

  return (
    <>
      <video
        muted={true}
        loop={true}
        autoPlay={true}
        src={idleVideo}
        style={{
          height: '100%',
          width: '100vh',
        }}
        playsInline={true}
      ></video>
      <video
        key={videoSrc}
        ref={playerRef}
        muted={isIdle || muted}
        loop={false}
        autoPlay={true}
        onEnded={onEnded}
        playsInline={true}
        style={{
          height: '100%',
          width: '100vh',
          zIndex: 1,
          position: 'absolute',
          top: 0,
          left: 0,
          display: isIdle ? 'none' : 'block',
        }}
        src={videoSrc}
      >
        Your browser does not support HTML5 video.
      </video>
      <Button className="talking-head-mute-button" onClick={toggleMute}>
        {muted ? 'unmute' : 'mute'}
      </Button>
    </>
  );
};

export default TalkingHead;
